import React, { Component } from 'react';

import Division from './Division.js';
import Feature from './Feature.js';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';

import './Features.css';

class Features extends Component {

    render() {
        return (
            <section id={this.props.id} className='relative text-sm-start text-white gradient-primary'>

                <Division
                    color='white'
                    invert
                    block />

                <Feature
                    id='feature-event-detection'
                    title='Innovate.'
                    titleColor='secondary'
                    lead='Identifying Event-based Twitter Content'
                    content='A set of unique features is constructed including a bag-of-words profile comprised of related keywords from internet search query logs &amp; Wikipedia, sentiment indication &amp; named entity recognition alongside account metadata &amp; content-derived features from the Twitter API.'
                    display={
                        <FontAwesomeIcon icon={faTwitter} size='10x' />
                    }
                    href='#' />
                <Feature
                    id='feature-location-inference'
                    title='Research.'
                    titleColor='secondary'
                    lead='Inferring the Home Location of Twitter Users'
                    content="This paper presents an outline of a proposed system to jointly extract named entities and evaluate their geographic distribution. Additionally, an algorithm is developed for the efficient collection of user timelines leveraging the streaming API alongside a user's social network."
                    display={
                        <FontAwesomeIcon icon={faTwitter} size='10x' />
                    }
                    layoutTextLeft
                    href='#' />

                <Division
                    color='white'
                    block />

            </section>
        );
    }

}

export default Features;